import React, { lazy } from 'react';
import { RoutePath } from 'router/routes/routePath';

const StructuresAddPage = lazy(() => import('pages/structures-add'));
const StructuresEditPage = lazy(() => import('pages/structures-edit'));
const StructureManagePage = lazy(() => import('pages/structure-manage'));
const StructuresPage = lazy(() => import('pages/structures'));
const StructurePreviewPage = lazy(() => import('pages/structure-preview'));
const FinishingSchemePage = lazy(() => import('pages/finishing-scheme'));
const StructureCoordinationModePage = lazy(() => import('pages/structure-coordination-mode'));
const StructureDirectoryPage = lazy(() => import('pages/structure-directory'));
const ProfilePage = lazy(() => import('pages/profile'));
const DocumentComparePage = lazy(() => import('../../pages/document-compare'));

export const clientRoutes = [
    {
        path: RoutePath.Structures,
        component: <StructuresPage />,
    },
    {
        path: RoutePath.StructuresPreview,
        component: <StructurePreviewPage />,
    },
    {
        path: RoutePath.StructuresFloorFinishingScheme,
        component: <FinishingSchemePage />,
    },
    {
        path: RoutePath.StructuresCoordinationMode,
        component: <StructureCoordinationModePage />,
    },
    {
        path: RoutePath.StructuresDirectory,
        component: <StructureDirectoryPage />,
    },
    {
        path: RoutePath.StructuresAdd,
        component: <StructuresAddPage />,
    },
    {
        path: RoutePath.StructuresEdit,
        component: <StructuresEditPage />,
    },
    {
        path: RoutePath.StructuresManage,
        component: <StructureManagePage />,
    },
    {
        path: RoutePath.Profile,
        component: <ProfilePage />,
        noAdminAccess: true,
    },
    {
        path: RoutePath.DocumentCompare,
        component: <DocumentComparePage />,
    },
];
